import { navigate } from "hookrouter"

export default function Dashboard() {
  // TODO: implement dashboard with stats
  navigate("/dashboard/userDetails")
  return ""
}
